import React from 'react';

interface WelcomePageProps {
    onGetStarted: () => void;
}

const WelcomePage: React.FC<WelcomePageProps> = ({ onGetStarted }) => {
    return (
        <div className="flex flex-col items-center justify-center h-screen" style={{
            backgroundImage: "url('/images/fullimage.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}
        >
            <h1 className="text-6xl font-bold text-greek-black mb-8 font-cinzel z-10">Welcome to Epikon</h1>
            <button
                onClick={onGetStarted}
                className="px-8 py-4 bg-terracotta text-warm-cream text-xl font-semibold rounded-full hover:bg-golden-yellow hover:text-greek-black transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-golden-yellow focus:ring-offset-2 font-cinzel z-10"
            >
                Begin Your Odyssey
            </button>

            
        </div>
    );
};

export default WelcomePage;